const HomeView = () =>
  import(/* webpackChunkName: "homeView" */ "@/views/HomeView.vue");
const LoginView = () =>
  import(/* webpackChunkName: "loginView" */ "@/views/LoginView");
const ConfirmEmailView = () =>
  import(/* webpackChunkName: "confirmEmailView" */ "@/views/ConfirmEmailView");
const LoginChooseView = () =>
  import(/* webpackChunkName: "loginChooseView" */ "@/views/Login/ChooseView");
const LoginEmailView = () =>
  import(/* webpackChunkName: "loginEmailView" */ "@/views/Login/EmailView");
const LoginPasswordView = () =>
  import(
    /* webpackChunkName: "loginPasswordView" */ "@/views/Login/PasswordView"
  );
const ResetPasswordView = () =>
  import(
    /* webpackChunkName: "resetPasswordView" */ "@/views/Login/ResetPasswordView"
  );
const AccountView = () =>
  import(/* webpackChunkName: "accountView" */ "@/views/AccountView");
const MyPlaneView = () =>
  import(/* webpackChunkName: "myPlaneView" */ "@/views/Account/MyPlaneView");
const InvitedPlaneView = () =>
  import(
    /* webpackChunkName: "invitedPlaneView" */ "@/views/Account/InvitedPlaneView"
  );
const WalkthroughVideoView = () =>
  import(
    /* webpackChunkName: "walkthroughVideoView" */ "@/views/Account/WalkthroughVideoView"
  );
const MyTicketView = () =>
  import(/* webpackChunkName: "myTicketView" */ "@/views/Account/MyTicketView");
const MyAccountView = () =>
  import(
    /* webpackChunkName: "myAccountView" */ "@/views/Account/MyAccountView"
  );
const MyPointsView = () =>
  import(/* webpackChunkName: "myPointsView" */ "@/views/Account/MyPointsView");
const MyPlaneEvolutionView = () =>
  import(
    /* webpackChunkName: "myPlaneEvolutionView" */ "@/views/Account/MyPlane/EvolutionView"
  );
const PlaneLevelView = () =>
  import(
    /* webpackChunkName: "planeLevelView" */ "@/views/Account/MyPlaneEvolution/PlaneLevelView"
  );
const MyPlaneParticipantView = () =>
  import(
    /* webpackChunkName: "myPlaneParticipantView" */ "@/views/Account/MyPlane/ParticipantView"
  );
const ParticipantPlaneView = () =>
  import(
    /* webpackChunkName: "participantPlaneView" */ "@/views/Account/MyPlane/ParticipantPlaneView"
  );
const SettingsView = () =>
  import(
    /* webpackChunkName: "settingsView" */ "@/views/Account/MyAccount/SettingsView"
  );
const RegisterView = () =>
  import(/* webpackChunkName: "registerView" */ "@/views/RegisterView");
const OnBoardView = () =>
  import(/* webpackChunkName: "onBoardView" */ "@/views/Account/OnBoardView");
const OnBoardRequirementsView = () =>
  import(
    /* webpackChunkName: "onBoardView" */ "@/views/Account/OnBoard/RequirementsView"
  );
const InviteView = () =>
  import(/* webpackChunkName: "inviteView" */ "@/views/InviteView");
const NotFoundView = () =>
  import(/* webpackChunkName: "onBoardView" */ "@/views/NotFoundView");

export default [
  {
    path: "/login",
    component: LoginView,
    meta: {
      guest: true,
      dark: true,
    },
    children: [
      {
        path: "",
        name: "login",
        component: LoginChooseView,
        meta: {
          guest: true,
        },
      },
      {
        path: "email",
        name: "login-email",
        component: LoginEmailView,
        meta: {
          back: { name: "login" },
          guest: true,
        },
      },
      {
        path: "password",
        name: "login-password",
        component: LoginPasswordView,
        meta: {
          back: { name: "login-email" },
          guest: true,
        },
      },
      {
        path: "reset-password",
        name: "reset-password",
        component: ResetPasswordView,
        meta: {
          back: { name: "login-password" },
          guest: true,
        },
      },
    ],
  },
  {
    path: "/register",
    name: "register",
    component: RegisterView,
    meta: {
      guest: true,
      dark: true,
    },
  },
  {
    path: "/confirm-email",
    component: ConfirmEmailView,
    meta: {
      guest: true,
    },
  },
  {
    path: "/account",
    component: AccountView,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        name: "my-plane",
        component: MyPlaneView,
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: "my-account",
            name: "my-account",
            component: MyAccountView,
            meta: {
              requiresAuth: true,
            },
            children: [
              {
                path: "settings",
                name: "settings",
                component: SettingsView,
                meta: {
                  requiresAuth: true,
                },
              },
            ],
          },
          {
            path: "my-plane/evolution",
            name: "my-plane-evolution",
            component: MyPlaneEvolutionView,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: "my-plane/evolution/:id",
            name: "plane-level",
            component: PlaneLevelView,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: "my-plane/participants/:id",
            name: "my-plane-participant",
            component: MyPlaneParticipantView,
          },
          {
            path: "my-plane/participants/:pid/planes/:id",
            name: "my-plane-participant-plane",
            component: ParticipantPlaneView,
          },
        ],
      },
      {
        path: "my-ticket",
        name: "my-ticket",
        component: MyTicketView,
        props: route => convertIdsToNumber(route),
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: ":id",
            name: "my-ticket-details",
            component: MyAccountView,
            props: route => convertIdsToNumber(route),
            meta: {
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "my-points",
        name: "my-points",
        component: MyPointsView,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "invited-plane",
        name: "invited-plane",
        component: InvitedPlaneView,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "walkthrough-video",
        name: "walkthrough-video",
        component: WalkthroughVideoView,
        meta: {
          requiresAuth: true,
          walkthroughVideo: true,
        },
      },
    ],
  },
  {
    path: "/on-board",
    name: "on-board",
    component: OnBoardView,
    meta: {
      requiresAuth: true,
      onBoard: true,
      dark: true,
    },
    children: [
      {
        path: "requirements",
        name: "on-board-requirements",
        component: OnBoardRequirementsView,
        meta: {
          requiresAuth: true,
          onBoard: true,
        },
      },
    ],
  },
  {
    path: "/:slide?",
    name: "home",
    component: HomeView,
    meta: {
      guest: true,
      dark: true,
    },
    params: {
      slide: 0,
    },
  },
  {
    path: "/invite/:code",
    name: "invite",
    component: InviteView,
    props: true,
    meta: {
      dark: true,
      requiresAuth: false,
      invite: true,
    },
  },
  {
    path: "*",
    name: "not-found",
    component: NotFoundView,
    meta: {
      notFound: true,
      dark: true,
    },
  },
];

function convertIdsToNumber(route) {
  const params = route.params;
  Object.keys(params).forEach(key => {
    if (!key.toLocaleLowerCase().lastIndexOf("id") === false) {
      return;
    }

    params[key] = Number(params[key]);
  });

  return params;
}
